module.exports = __webpack_public_path__ + "static/assets/969aaca3d7c0ff67b664b24c2652fb12.svg";